// extracted by mini-css-extract-plugin
export default {"heading":"heading_heading__Xr81l"};